import gql from 'graphql-tag'

export const resetPasswordConfirm = gql`
  mutation resetPasswordConfirm($token: String!, $password: String!, $confirmPassword: String!) {
    resetPasswordConfirm(token: $token, password: $password, confirmPassword: $confirmPassword) {
      status
    }
  }
`
